import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.eggShell,
  iconColor: colors.brickOrange,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.smoke,
  textColorLight: colors.white
};
export default accordion;